import VideoModal from './videoModal';


export default VideoModal;